import { useState, type InputHTMLAttributes } from 'react';
import { Icon } from './Icon';

/**
 * حقلُ كلمة مرورٍ بزرِّ إظهارٍ/إخفاء — يُستعمل في الدخول والإعدادات.
 *
 * يمرّر كلَّ خصائص `input` القياسية، ويضيف الزرَّ وحدَه فوقها.
 */
export function PasswordInput({
  className,
  ...rest
}: InputHTMLAttributes<HTMLInputElement>) {
  const [show, setShow] = useState(false);
  return (
    <div className="pw-input">
      <input
        {...rest}
        type={show ? 'text' : 'password'}
        dir="ltr"
        className={`input${className ? ` ${className}` : ''}`}
      />
      <button
        type="button"
        className="pw-eye"
        aria-pressed={show}
        onClick={() => setShow((v) => !v)}
        title={show ? 'إخفاء كلمة المرور' : 'إظهار كلمة المرور'}
        aria-label={show ? 'إخفاء كلمة المرور' : 'إظهار كلمة المرور'}
      >
        <Icon name="eye" size={16} />
      </button>
    </div>
  );
}
